import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './login_forgot.module.scss';

type Props = {
  onClick: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
};

export const LoginForgot: FC<Props> = ({ onClick }) => (
  <div className={styles.container}>
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      data-test-id="show-forgot-password"
    >
      <FormattedMessage id="LoginForgot.tsx/1" />
    </button>
  </div>
);
